<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    width="300"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
      class="pt-4"
    >
      <v-list-item class="pa-4">
        <v-img
          :src="logo"
          max-height="80"
          contain
          class="mx-auto mb-2"
        />
      </v-list-item>
      <div class="text-center px-4 pb-2">
        <div class="text-h6 font-weight-bold white--text mb-1">TIK TIME KEEPER</div>
        <div class="text-caption text-opacity-70 white--text">Real-time. Real trust. Real results.</div>
      </div>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <template v-if="checkRole(item.roles)">
          <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          >
          <!--  -->
          </base-item-group>

          <base-item
            v-else
            :key="`item-${i}`"
            :item="item"
          />
        </template>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <template v-slot:append>
      <company-header small />

     <span class="text-caption">v: {{ $env.VUE_APP_CACHE_VERSION }}</span>
    </template>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
    mapGetters,
  } from 'vuex'
  import logo from './tik_logo.png'
  import CompanyHeader from '../../DashboardStat/CompanyHeader.vue'

  export default {
    name: 'DashboardCoreDrawer',

    components: {
      CompanyHeader,
    },

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      roles: JSON.parse(localStorage.getItem('roles')),
      logo,
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/app',
        },
        {
          title: 'attendance',
          to: '/app/attendance',
          icon: 'mdi-check-all',
        },
        {
          title: 'reports',
          icon: 'mdi-file-chart-outline',
          group: '/app/reports',
          children: [
            {
              title: 'detailTime',
              to: 'detailTime',
              icon: 'mdi-altimeter',
            },
            {
              title: 'detailOverTime',
              to: 'detailOverTime',
              icon: 'mdi-altimeter',
            },
            {
              title: 'timePerformanceReport',
              to: 'timePerformanceReport',
              icon: 'mdi-altimeter',
            },
            {
              title: 'manHourReport',
              to: 'manHourReport',
              icon: 'mdi-altimeter',
            },
            {
              title: 'leaveReport',
              to: 'leaveReport',
              icon: 'mdi-beach',
            },
            // {
            //   title: 'offenseReport',
            //   to: 'offenses',
            //   icon: 'mdi-gavel',
            // },
            // {
            //   title: 'notices',
            //   to: 'notices',
            //   icon: 'mdi-bell-alert',
            // },
          ],
        },
        {
          title: 'tsheets',
          to: '/app/time-sheets',
          icon: 'mdi-account-clock-outline',
        },
        // {
        //   icon: 'mdi-account',
        //   title: 'user',
        //   to: '/app/pages/user',
        // },
        // {
        //   title: 'rtables',
        //   icon: 'mdi-clipboard-outline',
        //   to: '/app/tables/regular-tables',
        // },
        // {
        //   title: 'trecords',
        //   to: '/app/time-records',
        //   icon: 'mdi-table-edit',
        //   roles: ['admin', 'TeamAdmin'],
        // },

        {
          title: 'members',
          icon: 'mdi-account-group',
          group: '/app/members',
          children: [
            {
              title: 'members',
              to: 'list',
              icon: 'mdi-account-group',
              roles: ['head', 'TeamAdmin', 'hr'],
            },
            {
              title: 'newMembers',
              to: 'new',
              icon: 'mdi-account-arrow-left-outline',
              roles: ['admin', 'head', 'TeamAdmin', 'hr'],
            },
            {
              title: 'terminations',
              to: 'terminations',
              icon: 'mdi-account-arrow-right-outline',
              roles: ['head', 'TeamAdmin', 'hr'],
            },
          ],
        },

        // {
        //   title: 'members',
        //   to: '/app/members',
        //   icon: 'mdi-account-group',
        //   roles: ['head', 'TeamAdmin', 'hr'],
        // },
        {
          title: 'shifts',
          to: '/app/shifts',
          icon: 'mdi-image-filter-tilt-shift',
          roles: ['head', 'TeamAdmin', 'supervisor'],
        },

        {
          title: 'requests',
          to: '/app/requests',
          icon: 'mdi-clipboard-check-outline',
          roles: ['admin', 'editor'],
        },
        {
          title: 'annualLeave',
          to: '/app/annual-leave',
          icon: 'mdi-calendar-star',
          roles: ['hr-head'],
        },

        {
          title: 'admin',
          icon: 'mdi-security',
          group: '/app/admin',
          roles: ['super-admin'],
          children: [
            {
              title: 'users',
              to: 'users',
              icon: 'mdi-account-multiple',
              roles: ['super-admin'],
            },
            {
              title: 'teams',
              to: 'teams',
              icon: 'mdi-home-group',
              roles: ['super-admin'],
            },
            {
              title: 'groups',
              to: 'groups',
              icon: 'mdi-account-group',
              roles: ['super-admin'],
            },
            // {
            //   title: 'offenseRules',
            //   to: 'offenseTypes',
            //   icon: 'mdi-gavel',
            //   roles: ['super-admin'],
            // },
        //     {
        //   title: 'Notice Types',
        //   icon: 'mdi-bell-alert',
        //   to: 'noticeTypes',
        //   roles: ['super-admin'],
        // },
        {
          title: 'Company Settings',
          icon: 'mdi-cog',
          to: 'company-settings',
          roles: ['super-admin'],
        },
        {
          title: 'auditLogs',
          to: 'audit-logs',
          icon: 'mdi-clipboard-text-outline',
          roles: ['super-admin'],
        },
          ],
        },
        // {
        //   title: 'typography',
        //   icon: 'mdi-format-font',
        //   to: '/app/components/typography',
        // },
        // {
        //   title: 'icons',
        //   icon: 'mdi-chart-bubble',
        //   to: '/app/components/icons',
        // },
        // {
        //   title: 'google',
        //   icon: 'mdi-map-marker',
        //   to: '/app/maps/google-maps',
        // },
        // {
        //   title: 'notifications',
        //   icon: 'mdi-bell',
        //   to: '/app/components/notifications',
        // },
   
      ],
    }),

    computed: {
      ...mapState('app', ['barColor', 'barImage']),
      ...mapGetters(['groupLabelPlural']),
      drawer: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.$store.commit('app/SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    methods: {
      checkRole (roles) {
        if (!roles) {
          return true
        } else {
          return this.roles.some(r => roles.includes(r))
        }
      },
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: item.title === 'groups' ? this.groupLabelPlural : this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    font-size: 15px
    
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      font-size: 15px !important
      min-height: 50px !important
      
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 24px
        font-size: 20px !important

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important
      
      &__title
        font-size: 15px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        font-size: 14px !important
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
